var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkdetials(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14_4320)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.69302 13.8097C2.3703 13.8097 2.10777 13.5473 2.10777 13.2246V2.9258C2.10777 2.60319 2.3703 2.34066 2.69302 2.34066H3.65845V4.65202H9.51004V2.34066H10.4463C10.769 2.34066 11.0315 2.60319 11.0315 2.9258V9.4265L12.2018 8.12347V2.9258C12.2018 1.95786 11.4143 1.17027 10.4463 1.17027H8.23952C7.99805 0.48912 7.34722 0 6.58424 0C5.82138 0 5.17056 0.48912 4.92909 1.17027H2.69302C1.72497 1.17027 0.9375 1.95786 0.9375 2.9258V13.2246C0.9375 14.1926 1.72497 14.9801 2.69302 14.9801H7.45342L6.22398 13.8097H2.69302ZM5.99911 2.34066V1.75552C5.99911 1.4328 6.26164 1.17027 6.58424 1.17027C6.90697 1.17027 7.1695 1.4328 7.1695 1.75552V2.34066H8.33977V3.48175H4.82883V2.34066H5.99911ZM9.86115 6.99268H5.61882V5.8223H9.86115V6.99268ZM4.44843 5.8223V6.99268H3.27816V5.8223H4.44843ZM5.648 9.33334V8.16296H9.86115V9.33334H5.648ZM4.47773 9.33334H3.27816V8.16296H4.47773V9.33334ZM3.27816 10.5036H4.44843V11.6739H3.27816V10.5036ZM14.0416 9.57802L9.17175 15L6.00529 11.9859L6.81221 11.1382L9.10606 13.3217L13.1709 8.79593L14.0416 9.57802Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14_4320"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkdetials);
export default __webpack_public_path__ + "static/media/workdetials.8a60491a46ce3aa3dfb48717f67ac994.svg";
export { ForwardRef as ReactComponent };